import React, { useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

import divider from '../images/kozmetik/newPhoto2.jpg'
import TaniTedaviSideMenu from '../components/TaniVeTedavi/TaniTedaviSideMenu';

import TaniTedavi1 from '../components/TaniVeTedavi/TaniTedavi1';
import TaniTedavi2 from '../components/TaniVeTedavi/TaniTedavi2';
import TaniTedavi3 from '../components/TaniVeTedavi/TaniTedavi3';
import TaniTedavi4 from '../components/TaniVeTedavi/TaniTedavi4';
import TaniTedavi5 from '../components/TaniVeTedavi/TaniTedavi5';
import TaniTedavi6 from '../components/TaniVeTedavi/TaniTedavi6';
import TaniTedavi7 from '../components/TaniVeTedavi/TaniTedavi7';
import TaniTedavi8 from '../components/TaniVeTedavi/TaniTedavi8';
import TaniTedavi9 from '../components/TaniVeTedavi/TaniTedavi9';
import TaniTedavi10 from '../components/TaniVeTedavi/TaniTedavi10';
import TaniTedavi11 from '../components/TaniVeTedavi/TaniTedavi11';
import TaniTedavi12 from '../components/TaniVeTedavi/TaniTedavi12';
import TaniTedavi13 from '../components/TaniVeTedavi/TaniTedavi13';
import TaniTedavi14 from '../components/TaniVeTedavi/TaniTedavi14';
import TaniTedavi15 from '../components/TaniVeTedavi/TaniTedavi15';
import TaniTedavi16 from '../components/TaniVeTedavi/TaniTedavi16';
import TaniTedavi17 from '../components/TaniVeTedavi/TaniTedavi17';

import '../styles/about.css'

const TaniTedaviMain = () => {
  const [activeMenuItem, setActiveMenuItem] = useState('Deri Hastalıklarının Tanı Ve Tedavisi');

  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(menuItem);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const renderContent = () => {
    switch (activeMenuItem) {
        case 'Deri Hastalıklarının Tanı Ve Tedavisi':
            return <TaniTedavi1 />;
        case 'Allerjik Hastalıklar Tanı Ve Tedavisi':
            return <TaniTedavi2 />;
        case 'Alerji Testleri':
            return <TaniTedavi3 />;
        case 'Deri Biopsisi':
            return <TaniTedavi4 />;
        case 'Elektro Koterizasyon':
            return <TaniTedavi5 />;
        case 'Kriyoterapi':
            return <TaniTedavi6 />;
        case 'Küçük Cerrahi Girişimler':
            return <TaniTedavi7 />;
        case 'Mantar Hastalıkları Ve Tedavisi':
            return <TaniTedavi8 />;
        case 'Güneş Lekeleri Nedir, Korunma Ve Tedavi Yöntemleri Nelerdir?':
            return <TaniTedavi9 />;
        case 'Kimyasal Peeling Nedir, Hangi Alanlarda Kullanılır?':
            return <TaniTedavi10 />;
        case 'Botox Nedir, Hangi Amaçlarla Kullanılır?':
            return <TaniTedavi11 />;
        case 'Dolgu Nedir, Niçin Uygulanır?':
            return <TaniTedavi12 />;
        case 'Prp Nedir, Niçin Uygulanır?':
            return <TaniTedavi13 />;
        case 'Mezoterapi Nedir, Nerelerde Kullanılır?':
            return <TaniTedavi14 />;
        case 'Akne Vulgaris Nedir Ve Nasıl Oluşur?':
            return <TaniTedavi15 />;
        case 'Ürtiker (Kurdeşen)':
            return <TaniTedavi16 />;
        case 'Uçuk':
            return <TaniTedavi17 />;
        default:
            return null;
    }
};




  return (
    <div className='about-page'>
      <Image src={divider} fluid className="about-img" />
      <Container>
        <Row className='mt-4'>
          <Col lg={3} className='d-none d-lg-block'>
            <TaniTedaviSideMenu handleMenuItemClick={handleMenuItemClick} activeMenuItem={activeMenuItem} />
          </Col>
          <Col lg={9} className='d-none d-lg-block'>
            <div className="content">
              {renderContent()}
            </div>
          </Col>
          <Col xs={12} className='d-block d-lg-none'>
            <div className="content">
              {renderContent()}
            </div>
          </Col>
          <Col xs={12} className='d-block d-lg-none'>
            <TaniTedaviSideMenu handleMenuItemClick={handleMenuItemClick} activeMenuItem={activeMenuItem} />
          </Col>
        </Row>
      </Container>
    </div>

  );
};

export default TaniTedaviMain;
